var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeA14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 6,
    fill: "#F58220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.677 24L10.821 7.2H14.277L20.421 24H17.157L15.813 20.112H9.261L7.893 24H4.677ZM10.101 17.712H14.973L12.525 10.728L10.101 17.712ZM23.6826 24V10.704L20.9226 11.352V9L24.9786 7.2H26.8746V24H23.6826ZM37.812 24V20.88H29.532V18.432L37.404 7.2H40.884V18.216H43.092V20.88H40.884V24H37.812ZM32.82 18.216H38.004V10.584L32.82 18.216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeA14);
export default __webpack_public_path__ + "static/media/age-a14.f2cdd2dcc246f1354a94b017f25e4c7b.svg";
export { ForwardRef as ReactComponent };